/**
 * Shopify 原生 Cookie 横幅 + Google Consent Mode v2
 * 适用于 EEA 国家，自动监听 Shopify 原生横幅事件
 */

// ============ 1. 定义 EEA 国家列表 ============
var EEA_country_list = [
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", 
  "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", 
  "SI", "ES", "SE", "GB", "GF", "GP", "MQ", "ME", "YT", "RE", "MF", "GI", 
  "AX", "PM", "GL", "BL", "SX", "AW", "CW", "WF", "PF", "NC", "TF", "AI", 
  "BM", "IO", "VG", "KY", "FK", "MS", "PN", "SH", "GS", "TC", "AD", "LI", 
  "MC", "SM", "VA", "JE", "GG", "GI", "CH"
];

// ============ 2. 定义默认拒绝状态 ============
var gcs_default_consent = {
  ad_storage: "denied",
  analytics_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  wait_for_update: 500
};

// ============ 3. 初始化 dataLayer 和 gtag ============
window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}

// ============ 4. 工具函数：读取 Cookie ============
function getCookie(name) {
  var nameEQ = name + "=";
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

// ============ 5. 核心函数：设置默认 / 更新同意 ============
function setDefaultConsent(status) {
  console.log("[Consent Mode] 设置默认状态:", status);
  gtag("consent", "default", status);
}

function updateConsent(status) {
  console.log("[Consent Mode] 更新同意状态:", status);
  gtag("consent", "update", status);
}

// ============ 6. 主逻辑：读取 Shopify 同意状态并应用 ============
function applyConsentMode() {
  // 先设置默认拒绝
  setDefaultConsent(gcs_default_consent);

  // 尝试读取 Shopify 的同意 Cookie
  var shopifyConsentCookie = getCookie("_tracking_consent");
  if (!shopifyConsentCookie) {
    console.log("[Consent Mode] 未找到 _tracking_consent Cookie，保持默认拒绝");
    return;
  }

  try {
    var consentData = JSON.parse(decodeURIComponent(shopifyConsentCookie));
    console.log("[Consent Mode] 读取到 Shopify 同意数据:", consentData);

    // 检查是否有 CMP 数据（Shopify 原生横幅会写入 con.CMP）
    var cmp = consentData.con && consentData.con.CMP;
    if (!cmp) {
      console.log("[Consent Mode] 未找到 CMP 同意数据，保持默认拒绝");
      return;
    }

    // 映射 Shopify 的同意状态到 Google Consent Mode
    // cmp.a = analytics (分析) , cmp.m = marketing (营销)
    var analyticsGranted = cmp.a === "1" ? "granted" : "denied";
    var marketingGranted = cmp.m === "1" ? "granted" : "denied";

    updateConsent({
      ad_storage: marketingGranted,
      analytics_storage: analyticsGranted,
      ad_user_data: marketingGranted,
      ad_personalization: marketingGranted
    });

  } catch (e) {
    console.log("[Consent Mode] 解析 Cookie 失败:", e);
  }
}

// ============ 7. 监听 Shopify 原生横幅的交互事件 ============
document.addEventListener("visitorConsentCollected", function(event) {
  console.log("[Consent Mode] 捕获到 visitorConsentCollected 事件:", event.detail);

  var detail = event.detail || {};
  var marketingGranted = detail.marketingAllowed ? "granted" : "denied";
  var analyticsGranted = detail.analyticsAllowed ? "granted" : "denied";

  updateConsent({
    ad_storage: marketingGranted,
    analytics_storage: analyticsGranted,
    ad_user_data: marketingGranted,
    ad_personalization: marketingGranted
  });

  // 同时推送到 dataLayer，方便 GTM 使用
  dataLayer.push({
    event: "update_cookies_consent",
    ad_storage: marketingGranted,
    analytics_storage: analyticsGranted,
    ad_user_data: marketingGranted,
    ad_personalization: marketingGranted
  });
});

// ============ 8. 判断是否在 EEA 国家，决定是否启用 ============
// 优先从 Shopify 获取国家信息
var country = "";
try {
  if (window.Shopify && window.Shopify.customerPrivacy) {
    var region = window.Shopify.customerPrivacy.getRegion() || "";
    country = region.substr(0, 2);
  }
} catch (e) {
  console.log("[Consent Mode] 获取国家信息失败:", e);
}

console.log("[Consent Mode] 检测到国家:", country);

if (country && EEA_country_list.indexOf(country) !== -1) {
  console.log("[Consent Mode] 国家在 EEA 列表中，启用 Consent Mode");
  applyConsentMode();
} else {
  console.log("[Consent Mode] 国家不在 EEA 列表中，跳过 Consent Mode");
  // 非 EEA 国家可以直接设置为同意，或保持默认
  // 这里保持默认拒绝，你也可以改为默认同意
}
